export default "__VITE_ASSET__DGnEBBqx__"